import { AnalyticsName } from "./constants";

export const analyticsNames: Record<AnalyticsName, string> = {
  [AnalyticsName.XRF]: "XRF",
  [AnalyticsName.XRD]: "XRD",
  [AnalyticsName.SPEC_CAM]: "SpecCam",
  [AnalyticsName.QEM_SCAN]: "QemScan",
  [AnalyticsName.TOC]: "TOC",
};
